import { createReducer, on } from "@ngrx/store";
import { RemarkData } from "../../models/remarkDataModel";
import {
    clearRemarkData,
    createRemarkData,
    createRemarkDataError,
    createRemarkDataSuccess,
    fetchRemarkData,
    fetchRemarkDataError,
    fetchCurrentAndNextYearTrafficData,
    fetchCurrentYearTrafficData,
    fetchTrafficDataError,
    setRemarkData,
    updateRemarkData,
    updateRemarkDataError,
    updateRemarkDataSuccess,
    updateTrafficData
} from "./createoredit.action";
import { GetAllWrappedResponse } from "../../models/getAllWrappedDataModel";

export interface CreateOrEditState {
  fetchingTrafficData: boolean,
  fetchingRemarkData: boolean,
  savingRemark: boolean,
  trafficData: GetAllWrappedResponse["data"],
  remark: RemarkData | null,
  error: any | null,
}

export const initialState: CreateOrEditState = {
    fetchingTrafficData: false,
    fetchingRemarkData: false,
    savingRemark: false,
    trafficData: [],
    remark: null,
    error: null,
}

export const createOrEditReducer = createReducer(
    initialState,
    on(fetchCurrentAndNextYearTrafficData, state => ({
        ...state,
        fetchingTrafficData: true,
        error: null
    })),
    on(fetchCurrentYearTrafficData, state => ({
        ...state,
        fetchingTrafficData: true,
        error: null
    })),
    on(updateTrafficData, (state, { trafficData }) => ({
        ...state,
        trafficData,
        fetchingTrafficData: false,
        error: null
    })),
    on(fetchTrafficDataError, (state, { error }) => ({
        ...state,
        fetchingTrafficData: false,
        error
    })),
    on(clearRemarkData, state => ({
        ...state,
        remark: null,
        fetchingRemarkData: false,
        error: null
    })),
    on(fetchRemarkData, state => ({
        ...state,
        fetchingRemarkData: true,
        error: null
    })),
    on(setRemarkData, (state, { remark }) => ({
        ...state,
        remark,
        fetchingRemarkData: false,
        error: null
    })),
    on(fetchRemarkDataError, (state, { error }) => ({
        ...state,
        fetchingRemarkData: false,
        error
    })),
    on(createRemarkData, state => ({
        ...state,
        savingRemark: true,
        error: null
    })),
    on(createRemarkDataSuccess, state => ({
        ...state,
        savingRemark: false,
        error: null
    })),
    on(createRemarkDataError, (state, { error }) => ({
        ...state,
        savingRemark: false,
        error
    })),
    on(updateRemarkData, state => ({
        ...state,
        savingRemark: true,
        error: null
    })),
    on(updateRemarkDataSuccess, state => ({
        ...state,
        savingRemark: false,
        error: null
    })),
    on(updateRemarkDataError, (state, { error }) => ({
        ...state,
        savingRemark: false,
        error
    })),
)
